import { IAppContext } from "app-context";

export const useInitialContextValues = () => {
    const initialContext: IAppContext = {
        isAuthReady: false,
        userId: undefined,
        companyId: undefined,
        companyLocation: undefined,
        customerCompanyId: undefined,
        companyLogo: undefined,
        isPhoneVerified: false,
        numOfContactRqsts: 0,
        transporterContactsRqstd: [],
        kycPopupInitialLoad: 0,
        historyLocation: undefined,
        isMobile: true,
        currentLocation: { status: "notRequested" },
        profilesViewed: [],
        eventCounts: {
            citySearchCount: 0,
            transporterSearchCount: 0
        },
        showAppMandatePopup: false,
        thirdPartyCompanyName: "",
        isProductionEnv: false,
        isMobileScreen: false,
        isLorryNotAllowedPopupOpen: false,
        toggleIsLorryNotAllowedPopupOpen: () => {},
        joinedOn: ""
    };

    return initialContext;
};
